import React, { useCallback } from 'react';

import ProgressBarPanel from 'components/experiment/ui/ProgressBarPanel.component';
import CodeInput from 'components/form/CodeInput.component';
import KnobInput from 'components/form/KnobInput.component';
import MoneyInput from 'components/form/MoneyInput.component';
import CalendarInput from 'components/generic/CalendarInput.component';
import FootButton from 'components/login/FootButton.component';
import useStateWhileMounted from 'hooks/useStateWhileMounted.hook';
import { nowAsZulu } from 'utils/date/now.util';
import createNodeKey from 'utils/react/createNodeKey.util';

import CN from './FormPage.module.scss';

const A = { a: 1 };
const B = { b: 2 };

// TODO: maybe add tab navigation between different panels
const FormPage = () => {
  const [money, setMoney] = useStateWhileMounted(3.14);
  const [knobValue, setKnobValue] = useStateWhileMounted();
  const [footValue, setFootValue] = useStateWhileMounted();
  const [codeValue, setCodeValue] = useStateWhileMounted();
  const [selected, setSelected] = useStateWhileMounted('');

  const handleFoot = useCallback((ev) => void setFootValue(ev.tag), [setFootValue]);
  const handleCode = useCallback((ev) => void setCodeValue(ev.tag), [setCodeValue]);
  const handleMoney = useCallback(
    ({ coin, number, string, raw, value }) => void setMoney({ raw, coin, number, string, value }),
    [setMoney],
  );

  const handleKnob = useCallback(
    (ev) => {
      setSelected(selected === ev.name ? null : ev.name);
      setKnobValue(ev.raw);
    },
    [selected, setSelected, setKnobValue],
  );

  const values = [1, 2, 3, 'apple', 'banana', 'citrus', A, B];

  return (
    <div data-bem="FormPage" className={CN.component}>
      <h1>Some form elements</h1>

      <p>Progress line</p>
      <p>
        <ProgressBarPanel />
      </p>

      <p>Calendar</p>
      <div className={CN.horizontal}>
        <CalendarInput name="dateLeft" value={nowAsZulu()} />
        <CalendarInput name="dateRight" value={nowAsZulu()} align="right" />
      </div>

      <p>
        <span>Money input </span>
        <span>value: {JSON.stringify(money.value)} </span>
        <span>raw: {JSON.stringify(money.raw)} </span>
        <span>coin: {JSON.stringify(money.coin)} </span>
        <span>number: {JSON.stringify(money.number)} </span>
        <span>string: {JSON.stringify(money.string)} </span>
      </p>
      <p>
        <MoneyInput value={money} onChange={handleMoney} />
      </p>

      <p>
        <span>Foot button tag:</span>
        <span>{JSON.stringify(footValue)}</span>
      </p>
      <div className={CN.horizontal}>
        <FootButton tag="normal button" onClick={handleFoot} />
        <FootButton tag="disabled button" disabled onClick={handleFoot} />
        <FootButton tag="loading button" isLoading onClick={handleFoot} />
        <FootButton tag="disabled and loading button" disabled isLoading onClick={handleFoot} />
      </div>

      <p>
        <span>Code value:</span>
        <span>{JSON.stringify(codeValue)}</span>
      </p>
      <div className={CN.code}>
        <CodeInput onClick={handleCode} />
      </div>

      <p>
        <span>Knob value:</span>
        <span>{JSON.stringify(knobValue)}</span>
      </p>

      <div className={CN.knobs}>
        {values.map((value, index) => {
          const key = createNodeKey({ index, tag: 'knob' });
          const isSelected = selected === key;
          return (
            <KnobInput key={key} name={key} tag={key} value={value} selected={isSelected} onClick={handleKnob}>
              Knob for <strong>{JSON.stringify(value)}</strong>
            </KnobInput>
          );
        })}
      </div>
    </div>
  );
};
export default FormPage;
